import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  new_user: {
    id: null,
    type: null,
    email: null,
    include_in_mailshot: null,
  },
  showBoxes: {
    login: false,
    forgot_password: false,
    verification_code: false,
    set_new_password: false,
  },
  // _token: null,
  isLoading: false,
  signUpData: null,
  showEmailVerificationModal: false,
  showAccountVerificationModal: false,
  accountVerificationFrom: "",
  showLoginButton: false,
  emailVerifyData: {
    userId: null,
    userTypes: null,
    isEmailValidated: false,
    hasPassword: false,
    has_branch: null,
    has_agencies: 0,
    agencies: [],
    selectedAgencyUserId: null,
  },
  loginAccessData: {
    email: null,
    password: null,
    branchAccessIds: [],
    selectbranchAccessIds: null,
    isAccess: 0,
  },
  showLoginBranchesModal: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    /**
     * Updates the show boxes in the state based on the given action.
     *
     * @param {Object} state - the current state object
     * @param {Object} action - the action object containing the payload
     * @return {void}
     */
    updateShowBoxes: (state, action) => {
      const defaultShowBoxes = {
        login: false,
        forgot_password: false,
        verification_code: false,
        set_new_password: false,
      };
      state.showBoxes = {
        ...defaultShowBoxes,
        [action.payload]: true,
      };
    },
    /**
     * Updates the new user state with the given action payload.
     */
    updateNewUser: (state, action) => {
      state.new_user = {
        ...state.new_user,
        ...action.payload,
      };
    },

    updateLoginAccessData: (state, action) => {
      state.loginAccessData = { ...state.loginAccessData, ...action.payload };

      // console.log("login access",state.loginAccessData)
    },
    updateEmailVerifyData: (state, action) => {
      state.emailVerifyData = { ...state.emailVerifyData, ...action.payload };
    },
    toggleLoginBranchesModal: (state, action) => {
      state.showLoginBranchesModal = action.payload;
    },

    /**
     * Resets the new user state by setting id, type, and email to null.
     */
    resetNewUser: (state, action) => {
      state.new_user = {
        id: null,
        type: null,
        email: null,
      };
    },
    /**
     * Toggles the state of the email verification modal.
     *
     * @param {type} state - the current state
     * @param {type} action - the action triggering the toggle
     * @return {type} the updated state with the email verification modal toggled
     */
    toggleEmailVerificationModal: (state, action) => {
      state.showEmailVerificationModal = !state.showEmailVerificationModal;
    },
    /**
     * toggleAccountVerificationModal - Toggles the visibility of the account verification modal.
     *
     * @param {Object} state - The current state object
     * @param {Object} action - The action object
     */
    toggleAccountVerificationModal: (state, action) => {
      state.showAccountVerificationModal = !state.showAccountVerificationModal;
    },

    /**
     * Updates the sign-up data in the state.
     *
     * @param {type} state - the state object
     * @param {type} action - the action object
     * @return {type} undefined
     */
    updateSignUpData: (state, action) => {
      state.signUpData = action.payload;
    },
    /**
     * Update the account verification from the given state with the provided action.
     *
     * @param {type} state - description of state parameter
     * @param {type} action - description of action parameter
     * @return {type} description of return value
     */
    updateAccountVerificationFrom: (state, action) => {
      state.accountVerificationFrom = action.payload;
    },
    updateLoginButton: (state, action) => {
      state.showLoginButton = action.payload;
    },
  },
});

export const {
  updateShowBoxes,
  updateNewUser,
  resetNewUser,
  toggleLoginBranchesModal,
  updateLoginAccessData,
  toggleEmailVerificationModal,
  toggleAccountVerificationModal,
  updateEmailVerifyData,
  // updateCSRFToken,
  updateSignUpData,
  updateAccountVerificationFrom,
} = authSlice.actions;

export default authSlice.reducer;
